import { get, post, put } from 'helpers/api';

const rootPath = '/backoffice/contacts';

export async function searchContacts({ query, type }, callback) {
  const results = await get(`${rootPath}/search`, { params: { query, type } });
  callback(results);
}

// Persist just a contact's QuickBooks link (customers map to quickbooksCustomerId, vendors to
// quickbooksVendorId). Returns the serialized contact.
export async function updateContactQuickbooksId(contactId, type, quickbooksId) {
  const key = type === 'customer' ? 'quickbooksCustomerId' : 'quickbooksVendorId';
  return await put(`${rootPath}/${contactId}`, { [key]: quickbooksId });
}

export async function updateContact(contactId, attributes) {
  return await put(`${rootPath}/${contactId}`, attributes);
}

export async function saveContact(contact, forRecord, {
  apiHelpers = {},
  params = {},
} = {}) {
  const body = {
    ...contact,
    // Distinguish between "clear" (quickbooksCustomer: null) and "never changed"
    // quickbooksCustomer not present. Fall back to the quickbooksId to prevent clearing accidentally.
    quickbooksCustomerId: 'quickbooksCustomer' in contact
      ? contact.quickbooksCustomer && contact.quickbooksCustomer.id
      : contact.quickbooksCustomerId,
    quickbooksVendorId: 'quickbooksVendor' in contact
      ? contact.quickbooksVendor && contact.quickbooksVendor.id
      : contact.quickbooksVendorId,
    additionalEmailsAttributes: contact.additionalEmails,
    addressesAttributes: contact.addresses,
    phoneNumbersAttributes: contact.phoneNumbers,
  };

  body.businessRecordsAttributes = [];
  for (const { business, ...attributes } of contact.businessRecords) {
    if (business?.id) {
      body.businessRecordsAttributes.push({
        ...attributes,
        businessId: business.id,
      });
    } else if (business?.crmContactId && business?.crmContactType) {
      body.businessRecordsAttributes.push({
        ...attributes,
        crmContactId: business.crmContactId,
        crmContactType: business.crmContactType,
      });
    }
  }

  if (contact.crmTags) {
    body.crmTagsAttributes = contact.crmTags;
  }

  delete body.additionalEmails;
  delete body.addresses;
  delete body.businessRecords;
  delete body.phoneNumbers;
  delete body.crmTags;
  delete body.quickbooksCustomer;
  delete body.quickbooksVendor;

  body.forRecord = forRecord;

  let method, path;
  if (body.id) {
    method = apiHelpers.put || put;
    path = `${rootPath}/${body.id}`;
  } else {
    method = apiHelpers.post || post;
    path = rootPath;
  }

  if (params && Object.keys(params).length) {
    path = `${path}?${new URLSearchParams(params)}`;
  }

  return await method(path, body);
}
